import Image from 'next/image';
import Link from 'next/link';
import { Button } from '@app/components/shadcn-ui/button';
import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

export default function ContactUsCard() {
    const router = useRouter();
    const isLandingContact = router.pathname === '/';

    const { t } = useTranslation('pricing');
    return (
        <div className="w-full max-w-[904px] ">
            <div className="contact-us-bg relative mt-10 flex flex-row justify-between gap-10 overflow-hidden rounded-xl border border-gray-300 p-8 ">
                <div className="absolute inset-0 left-28  h-full w-full ">
                    <Image className="" src="/svgs/gradient-wave.svg" alt="" width={727} height={272} objectFit="cover" />
                </div>
                <div className="z-10 text-left">
                    <div className="p1 max-w-[454px]">
                        <span className="mr-1  text-brand-accent-600">{t('contactUsCard.tryEnterprisePlan')}</span>
                        {t('contactUsCard.details')}
                    </div>
                    <Link href={isLandingContact ? '/contact-us' : `/${router.query.organizationId}/contact-us`}>
                        <Button className="mt-5" variant="default">
                            {t('contactUsCard.contactUs')}
                        </Button>
                    </Link>
                </div>
                <div className="absolute right-8 top-0 z-10 hidden lg:flex">
                    <Image src="/svgs/enterprise.svg" alt="" width={200} height={200} style={{ objectFit: 'cover', objectPosition: 'top' }} />
                </div>
            </div>
        </div>
    );
}
